var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 27,
    viewBox: "0 0 16 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 1H11C9.3424 1 7.75269 1.65848 6.58058 2.83058C5.40848 4.00269 4.75 5.5924 4.75 7.25V11H1V16H4.75V26H9.75V16H13.5L14.75 11H9.75V7.25C9.75 6.91848 9.8817 6.60054 10.1161 6.36612C10.3505 6.1317 10.6685 6 11 6H14.75V1Z",
    stroke: "#18161A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconBlack);
export default __webpack_public_path__ + "static/media/facebook-icon-black.89c3c899f4866d1017bceb445a645bb1.svg";
export { ForwardRef as ReactComponent };